import { Dialog, DialogContent, DialogActions, Button, RadioGroup, FormControlLabel, Radio, Typography, Box } from '@mui/material';
import { setMachineDetailsData } from '../../../redux/machineDetailsDataSlice'
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import Iconify from '../../Iconify';
import { useState } from 'react';
import axios from 'axios';

const archiveOptions = [
    { value: 'Vendue', label: 'Vendue' },
    { value: 'Volee', label: 'Volée' },
    { value: 'MiseEnDecharge', label: 'Mise en décharge' },
    { value: 'autre', label: 'Autre' },
];

const ArchiveMachineDialog = ({ machineDetailsData, openArchiveMachine, setOpenArchiveMachine }) => {

    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [selectedOption, setSelectedOption] = useState(archiveOptions[0]?.value);

    const handleArchiveMachine = async () => {
        try {
            const archive_reason = selectedOption === 'autre' ? null : selectedOption;

            const response = await axios.patch(`machine/machine_archive/${machineDetailsData?.id}`, { archive_reason });
            if (response.status === 200 || response.status === 201) {
                dispatch(setMachineDetailsData({ ...machineDetailsData, is_archived: true, archive_reason: response.data }));
            }
        } catch (error) {
            console.error(error, 'Error archiving machine');
            CustomErrorLogger(error, 'Error archiving machine');
        }
        finally {
            setOpenArchiveMachine(false);
        }
    };

    const handleClose = () => {
        setOpenArchiveMachine(false);
    };

    return (
        <Dialog open={openArchiveMachine} onClose={handleClose} maxWidth="sm" fullWidth>
            <Box onClick={handleClose} className='modifierTitre_icon_text'>
                <Typography className='modifierTitre_title'>Archiver la machine</Typography>
                <Iconify icon={"material-symbols:close"} className='modifierTitre_close_icon' />
            </Box>
            <DialogContent>
                <Box sx={{ py: 1 }}>
                    <Typography className="modifierTitreInputTitle">Sélectionnez la raison de l'archivage</Typography>
                    <RadioGroup
                        value={selectedOption}
                        onChange={(e) => setSelectedOption(e.target.value)}
                    >
                        {archiveOptions?.map((option) => (
                            <FormControlLabel
                                key={option.value}
                                value={option.value}
                                control={<Radio className='globalRadio' />}
                                label={t(option.label)}
                            />
                        ))}
                    </RadioGroup>
                </Box>
            </DialogContent>
            <DialogActions className='modifierTitre_dialog_actions'>
                <Button className='modifierTitre_button_annuler' onClick={handleClose}>{t('Annuler')}</Button>
                <Button className='modifierTitre_button_valider' variant="contained" onClick={handleArchiveMachine}>{t('Valider')}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ArchiveMachineDialog;